import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { ReferenceParams } from 'src/app/models';
import { ApiProductsService, FilesService, LanguageService, NotificationService } from 'src/app/services';

@Component({
  selector: 'app-customers-integration',
  templateUrl: './customers-integration.component.html',
  styleUrls: ['./customers-integration.component.css']
})
export class CustomersIntegrationComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  errorMessages: any;
  loading: boolean;
  providers: any[] = [];
  products: any[] = [];
  currentModule: string;

  form: UntypedFormGroup = this.fb.group({
    org_id: [null, Validators.required]
  });


  @Input() set data(value) {

    if (value) {

    }

  }

  constructor(
    public ngProgress: NgProgress,
    public activeModal: NgbActiveModal,
    private fb: UntypedFormBuilder,
    private languageService: LanguageService,
    private apiProducts: ApiProductsService,
    private router: Router,
    private notification: NotificationService,
    private fileService: FilesService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.currentModule = this.router.url;

    this.getProviders();

    if (this.currentModule == '/products') {

      this.subscriptions.add(

        this.form.get('org_id').valueChanges.subscribe(val => {

          val ? this.getProductForIntegration(val) : this.products = [];

        })
      );

    }

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }

  /**
  * 
  */
  getProviders(): void {

    let params: ReferenceParams = {
      ref_name: 'organizations_for_integration'
    }

    this.subscriptions.add(
      this.apiProducts.getReferences(params, params.ref_name).subscribe((response: any) => {

        console.log("getProviders: ", response);

        if (response.result != null) {

          this.providers = response.result;

          if (this.currentModule == '/settings') {

            this.setProdiversData(response.result);
          }
        }
      })
    );

  }


  /**
   * 
   * @param providers 
   */
  setProdiversData(providers: any) {

    let orgIds = providers.filter(val => val.checked).map(({ org_id }) => org_id);

    if (orgIds.length > 0) {

      this.form.get('org_id').setValue(orgIds);
    }

  }


  /**
   * 
   * @param org_id 
   */
  getProductForIntegration(org_id: string) {

    this.products = [];
    this.progressRef.start();
    this.loading = true;

    this.subscriptions.add(

      this.apiProducts.getProductForIntegration(org_id).subscribe((response: any) => {
        console.log("PRODUCTS LIST: ", response);

        if (response.result.data != null) {

          this.products = response.result.data;

          response.result.data.forEach(val => {

            this.getImageContent(val);
          });
        }

        this.progressRef.complete();
        this.loading = false;

      })
    );
  }

  /**
   * 
   * @param product Product
   */
  getImageContent(product: any): void {

    if (product.photo != "") {

      this.subscriptions.add(

        this.fileService.getImage(product.photo).subscribe((response: any) => {
          console.log("GET IMAGE: ", response);

          if (response != null) {

            product['file_small'] = response.result.small;
          }
        })
      );
    }
  }

  /**
   * 
   */
  onIntegrationProducts() {

    let obj = {
      providerOrgID: this.form.get('org_id').value,
      products: [...new Set(this.products.filter(val => val.checked).map(v => ({ id: v.id, name: v.name, barcode: v.barcode, article: v.article })))]
    }

    if (obj.providerOrgID) {

      this.subscriptions.add(

        this.apiProducts.onIntegrationProducts('integrateProducts', obj, 'files').subscribe((response: any) => {
          console.log("INTEGRATION RESPONSE: ", response);

          if (response != null) {

            this.notification.show('success', 'Данные' + ' ' + response.result + ' ' + 'товаров успешно добавлены!');
            this.activeModal.close(true);

          }

        })
      );

    }

  }

  /**
   * 
   */
  onCreateIntegration() {

    let obj = {

      id: this.form.get('org_id').value
    }


    this.subscriptions.add(

      this.apiProducts.onIntegrationProducts('orgs_integrations/create', obj, 'npc').subscribe((response: any) => {
        console.log("INTEGRATION SETTINGS RESPONSE: ", response);

        if(response.status == 1){
          
          this.notification.show('success', 'Данные успешно сохранены!');
        }

        

      })
    );

  }

  // CHECKBOX
  /**
   * 
   * @param index number
   * @param event 
   */
  selectedCheckBox(index: number, event: any): void {

    this.products[index].checked = event.target.checked;
  }


  /**
   * 
   * @param event 
   */
  checkAllCheckBox(event: any): void {

    this.products.forEach(x => x.checked = event.target.checked);
  }


  /**
   * 
   * @returns boolean
   */
  isAllCheckBoxChecked(): boolean {

    if (this.products.length == 0) return false;

    return this.products.every(p => p.checked);
  }


  /**
   * 
   * @returns boolean
   */
  checkedButNotAllCheckBox(): boolean {

    let pl = this.products.length;
    let pc = this.products.filter(val => val.checked).length;

    return (pc > 0 && pc < pl) ? true : false;
  }


  /**
   * 
   * @returns boolean
   */
  checkedCheckBox(): boolean {

    let pc = this.products.filter(val => val.checked).length;

    return (pc > 0) ? true : false;
  }
}
